import Select from "react-select";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getInvoicingMethodLabel } from "./invoicingMethodLabel";

export interface InvoicingMethodOption {
  value: EasyTech.InvoicingMethod;
  label: string;
}

export default function InvoicingMethodSelect({
  value,
  onChange,
  className = "",
  placeholder,
  disabled,
  isClearable = true,
}: {
  value?: EasyTech.InvoicingMethod | null;
  onChange: (value: EasyTech.InvoicingMethod | null) => void;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  isClearable?: boolean;
}) {
  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = useState<InvoicingMethodOption | null>(null);

  const options: InvoicingMethodOption[] = [
    { value: "FIXED_COST", label: getInvoicingMethodLabel("FIXED_COST", t) },
    { value: "DURATION_MIN", label: getInvoicingMethodLabel("DURATION_MIN", t) },
  ];

  useEffect(() => {
    if (value) {
      const match = options.find((opt) => opt.value === value);
      setSelectedOption(match || { value, label: value });
    } else {
      setSelectedOption(null);
    }
  }, [value, t]);

  return (
    <Select<InvoicingMethodOption>
      options={options}
      value={selectedOption}
      onChange={(opt) => onChange(opt ? opt.value : null)}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "rgb(14 165 233)",
        },
      })}
      className={`w-full ${className}`}
      classNamePrefix="react-select"
      placeholder={placeholder || t("admin:invoicingMethod", "Invoicing method")}
      isClearable={isClearable}
      isDisabled={disabled}
    />
  );
}
